export const jaTranslations = {
  'nav.home': 'ホーム',
  'nav.products': 'eSIM',
  'nav.contact': 'お問い合わせ',
  'product.customize': 'カスタマイズ',
  'product.price_oriented': '価格重視',
  'product.quality_oriented': '品質重視',
  'product.specs': 'スペック',
  'product.usage_days': '利用日数',
  'product.day': '日',
  'product.gb_per_day': '1日あたりGB',
  'product.unlimited': '使い放題',
  'checkout.title': 'ご注文',
  'checkout.email': 'メールアドレス',
  'checkout.email_placeholder': '例: example@mail.com',
  'checkout.card_info': 'カード情報',
  'checkout.card_number': 'カード番号',
  'checkout.expiry_date': '有効期限',
  'checkout.cvc': 'セキュリティコード',
  'checkout.pay': '決済する',
  'checkout.total': '合計',
  'checkout.tax': '税込',
  'checkout.terms': '利用規約に同意する',
  'footer.privacy': 'プライバシーポリシー',
  'footer.terms': '利用規約',
  'footer.company': '会社概要',
  'footer.law': '特定商取引法',
  'footer.copyright_tomaruyo': '© {year} TomaRuyo All Rights Reserved.',
  'hero.title': '日本国内で利用できるeSIMをお得に',
  'hero.subtitle': '快適な滞在と共に、スムーズな通信環境をお楽しみください。オリジナルeSIMで旅の思い出をシェアしましょう。',
  'hero.rb.subtitle': '快適な宿泊と共に、スムーズな通信環境をお楽しみください。R&Bホテルオリジナルのデータプランでビジネスもレジャーも快適に。',
  'hero.apa.title': '日本国内で利用できるeSIMをお得に入手',
  'hero.apa.subtitle': '快適な宿泊と共に、スムーズな通信環境をお楽しみください。アパホテルオリジナルのデータプランでビジネスもレジャーも快適に。',
  'hero.choice.title': '日本国内で利用できるeSIMをお得に',
  'hero.choice.subtitle': '快適な宿泊と共に、スムーズな通信環境をお楽しみください。チョイスホテルズジャパンオリジナルのデータプランでビジネスもレジャーも快適に。',
  'hero.choose_esim': 'eSIMを選ぶ',
  'hero.learn_more': '詳しく見る',
  'products.title': 'eSIMプラン',
  'products.subtitle': 'お好みの通信プランをお選びいただけます。価格重視のエコノミープランから、高品質な通信環境を提供するプレミアムプランまでご用意しています。',
  'products.all': 'すべて',
  'products.price_focus': '価格重視',
  'products.quality': '品質重視',
  'products.choose_plan': 'このプランを選ぶ',
  'products.selected': '選択中',
  'customization.days': '日',
  'customization.back': '戻る',
  'checkout.payment_info': 'お支払い情報',
  'checkout.secure_payment': 'Stripeによる安全な決済',
  'checkout.order_summary': '注文内容',
  'checkout.plan': 'プラン:',
  'checkout.data_amount': 'データ量:',
  'checkout.network': 'ネットワーク:',
  'checkout.usage_days': '利用日数:',
  'checkout.base_fee': '基本料金:',
  'checkout.days_fee': '日数料金:',
  'checkout.processing': '処理中...',
  'checkout.privacy_policy': 'プライバシーポリシー',
  'checkout.agree': 'に同意する',
  'thankyou.title': 'ご注文ありがとうございます！',
  'thankyou.message': 'ご注文内容の確認メールを {email} へ送信しました。24時間以内にeSIM情報をお送りいたします。',
  'thankyou.next_steps': '次のステップ',
  'thankyou.step1': 'メールを確認する',
  'thankyou.step2': 'eSIMの詳細が24時間以内にメールで届きます',
  'thankyou.step2_express': 'eSIMの詳細が30分以内にメールで届きます',
  'thankyou.step3': 'eSIMをインストールする',
  'thankyou.back_to_home': 'トップへ戻る',
  'thankyou.official_site': 'Super Hotel公式サイ���へ',
  'footer.links': 'リンク',
  'footer.official_website': '公式ウェブサイト',
  'footer.hotel_list': 'ホテル一覧',
  'footer.campaigns': 'キャンペーン',
  'footer.stay_plans': '宿泊プラン',
  'footer.information': 'インフォメーション',
  'footer.copyright': '© {year} Super Hotel Co., Ltd. All Rights Reserved.',
  
  'products.short_stay': '短期滞在プラン',
  'products.long_stay': '長期滞在プラン',
  'products.days': '日数',
  'products.data': 'データ量',
  'products.price_label': '販売価格',
  'products.after_data': '通信制限',
  'products.action': '注文',
  'products.days_suffix': '日',
  'products.data_filter': 'データ量でフィルタ',
  'products.days_filter': '滞在日数でフィルタ',
  'products.all_data': 'すべてのデータ量',
  'products.all_days': 'すべての滞在日数',
  'products.tax': '税',
  'products.no_products': '条件に一致するプランがありません',
  'products.coming_soon': 'Coming Soon...',
  'products.premium_coming_soon': 'プレミアムプランは近日公開予定です',
  'checkout.after_data': 'データ消費後',
  'checkout.delivery': '配送',
  'checkout.express_delivery': '30分以内にメール配信',
  'hero.rembrandt.title': '日本国内で利用できるeSIMをお得に',
  'hero.rembrandt.subtitle': '快適な宿泊と共に、スムーズな通信環境をお楽しみください。レンブラントホテルオリジナルのデータプランでビジネスもレジャーも快適に。',
  'thankyou.rb_official_site': 'R&B Hotel公式サイトへ',
  'thankyou.apa_official_site': 'アパホテル公式サイトへ',
  'thankyou.choice_official_site': 'チョイスホテルズジャパン公式サイトへ',
  'thankyou.rembrandt_official_site': 'レンブラントホテル公式サイトへ',
  'footer.rb_copyright': '© {year} R&B Hotel. All Rights Reserved.',
  'footer.apa_copyright': '© {year} APA HOTEL Co., Ltd. All Rights Reserved.',
  'footer.choice_copyright': '© {year} Choice Hotels Japan. All Rights Reserved.',
  'footer.rembrandt_copyright': '© {year} Rembrandt Group. All Rights Reserved.',
  'checkout.express_fee': '速達料金:',
  
  'checkout.tax_included': '（税込）',
  'products.standard_1day': '基本1日プラン',
  'products.standard_3days': '基本3日プラン',
  'products.standard_7days': '基本7日プラン',
  'products.standard_15days': '基本15日プラン',
  'products.standard_30days': '基本30日プラン',
  'products.standard_60days': '基本60日プラン',
  'products.standard_90days': '基本90日プラン',
  'products.premium_1day': 'プレミアム1日プラン',
  'products.premium_3days': 'プレミアム3日プラン',
  'products.premium_7days': 'プレミアム7日プラン',
  'products.premium_15days': 'プレミアム15日プラン', 
  'products.premium_30days': 'プレミアム30日プラン',
  'products.premium_60days': 'プレミアム60日プラン',
  'products.premium_90days': 'プレミアム90日プラン',
  'products.after_data_standard_1day': '128kbpsに低速化',
  'products.after_data_standard_3days': '128kbpsに低速化',
  'products.after_data_standard_7days': '128kbpsに低速化',
  'products.after_data_standard_15days': '128kbpsに低速化',
  'products.after_data_standard_30days': '128kbpsに低速化',
  'products.after_data_standard_60days': '128kbpsに低速化',
  'products.after_data_standard_90days': '128kbpsに低速化',
  'products.after_data_premium_1day': '1Mbpsに低速化',
  'products.after_data_premium_3days': '1Mbpsに低速化',
  'products.after_data_premium_7days': '1Mbpsに低速化',
  'products.after_data_premium_15days': '1Mbpsに低速化', 
  'products.after_data_premium_30days': '1Mbpsに低速化',
  'products.after_data_premium_60days': '1Mbpsに低速化',
  'products.after_data_premium_90days': '1Mbpsに低速化',
  
  'checkout.express_delivery_message': '通常24時間以内��ところ、30分以内に納品します（+¥550 税込）',
  'checkout.standard_delivery_message': '24時間以内にeSIMをメールでお送りします',
  'checkout.express_delivery_option': '30分以内にeSIMを受け取る（+¥550）',
  'thankyou.download_receipt': '領収書をダウンロード',
  'thankyou.get_receipt': '領収書を取得',
  'thankyou.loading_receipt': '領収書を読み込み中...',
  'thankyou.receipt_error_title': '領収書の取得エラー',
  'thankyou.receipt_error_description': '領収書の取得に失敗しました。少し時間をおいてから再試行してください。',
  
  'checkout.customer_info': '顧客情報',
  'checkout.basic_info': '基本情報',
  'checkout.additional_info': '追加情報 (オプション)',
  'checkout.name': 'お名前',
  'checkout.name_placeholder': '例: 山田 太郎',
  'checkout.phone': '電話番号',
  'checkout.phone_placeholder': '例: 09012345678',
  'checkout.country': '国籍/居住国',
  'checkout.country_placeholder': '国を選択してください',
  'checkout.device_info': 'デバイス情報',
  'checkout.device_info_placeholder': 'デバイスを選択してください',
  'checkout.travel_purpose': '旅行目的',
  'checkout.travel_purpose_placeholder': '目的を選択してください',
  'checkout.marketing_consent': 'お客様サポート、キャンペーン、プロモーション情報をメールで受け取ることに同意します',
  'checkout.support_info': 'お客様サポートに使用いたします。',
  
  'thank_you.title': 'ご注文ありがとうございます！',
  'thank_you.personalized': '{name}様、ご注文ありがとうございます！',
  'thank_you.email_sent': '注文の確認メールを以下のアドレスに送信しました：',
  'thank_you.next_steps': '次のステップ',
  'thank_you.download_receipt': 'レシート情報をダウンロード',
  'thank_you.receipt_desc': '下のボタンからレシートをダウンロードできます',
  'thank_you.download_button': 'レシートをダウンロード',
  'thank_you.esim_delivery': 'eSIMの受け取り',
  'thank_you.delivery_desc': 'eSIMの詳細は{0}にメールでお送りします',
  'thank_you.express_delivery_time': '30分以内',
  'thank_you.standard_delivery_time': '24時間以内',
  'thank_you.questions': 'ご質問がある場合',
  'thank_you.contact_desc': 'ご不明な点がございましたら、お気軽にお問い合わせください',
  'thank_you.back_button': 'ホームに戻る',
  'receipt.not_available': 'レシートが利用できません',
  'receipt.try_later': '後ほど再度お試しください',
  
  'checkout.complete_payment': '決済を完了する',
  'checkout.back': '戻る',
  
  'checkout.tourism': '観光',
  'checkout.business': 'ビジネス',
  'checkout.family': '家族訪問',
  'checkout.education': '留学/教育',
  'checkout.other': 'その他',
  'checkout.personal_info': '個人情報',
  'checkout.optional': '任意',
  'checkout.phone_description': 'カスタマーサポート用',
  'checkout.select_country': '国を選択してください',
  'checkout.device_info_description': '互換性確認のためのデバイス情報',
  'checkout.marketing_consent_description': 'いつでも配信を停止できます',
  'checkout.continue_to_payment': '決済へ進む',
  'checkout.customer_name': 'お名前',
  
  'auth.login': 'ログイン',
  'auth.email': 'メールアドレス',
  'auth.password': 'パスワード',
  'auth.forgot_password': 'パスワードをお忘れの方はこちら',
  'auth.login_button': 'ログイン',
  'auth.processing': '処理中...',
  'auth.error.title': 'エラー',
  'auth.error.credentials': 'メールアドレスまたはパスワードが正しくありません',
  'auth.confirm_purchase': '購入確認',
  
  // Add new translations for checkout section
  'checkout.proceed_to_order': '注文に進む',
  'checkout.selected_product': '選択した商品',
  'checkout.price': '価格',
  'checkout.proceed_to_checkout': '注文手続きに進む',
  'checkout.select_product': '商品を選択してください',
  
  // Add missing proceed to payment key
  'checkout.proceed_to_payment': '決済へ進む',
  
  // Add new UI element translations
  'checkout.payment': '決済情報',
  'checkout.cardholder_name': 'カード名義人',
  'checkout.reload_form': 'フォームを再読み込み',
  'admin.confirm_purchase': '購入確認',
  'admin.update_data': 'データを更新',
  
  // Add new admin translations
  'admin.confirm_update_message': 'すべての商品データを最新のデータで上書きします。よろしいですか？\n\n※この操作は元に戻せません。',
  'admin.updating_data': '商品データ更新中...',
  'admin.update_help_text': 'このボタンを押すと、指定された正確な商品データでデータベースを更新します',
  'admin.update_error': '商品データ更新中にエラーが発生しました:',
  
  // Add auth navigation translations
  'auth.mypage': 'マイページ',
  'auth.logout': 'ログアウト',
};
